import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5306 18.9694C15.6003 19.039 15.6556 19.1218 15.6933 19.2128C15.731 19.3039 15.7504 19.4014 15.7504 19.5C15.7504 19.5985 15.731 19.6961 15.6933 19.7872C15.6556 19.8782 15.6003 19.9609 15.5306 20.0306C15.4609 20.1003 15.3782 20.1556 15.2872 20.1933C15.1961 20.231 15.0985 20.2504 15 20.2504C14.9015 20.2504 14.8039 20.231 14.7128 20.1933C14.6218 20.1556 14.5391 20.1003 14.4694 20.0306L6.96938 12.5306C6.89964 12.461 6.84433 12.3782 6.80658 12.2872C6.76884 12.1961 6.74941 12.0986 6.74941 12C6.74941 11.9014 6.76884 11.8038 6.80658 11.7128C6.84433 11.6217 6.89964 11.539 6.96938 11.4694L14.4694 3.96936C14.6101 3.82863 14.801 3.74957 15 3.74957C15.199 3.74957 15.3899 3.82863 15.5306 3.96936C15.6714 4.1101 15.7504 4.30097 15.7504 4.49999C15.7504 4.69901 15.6714 4.88988 15.5306 5.03061L8.56031 12L15.5306 18.9694Z",
		fill: "current"
	})
});
export default SvgArrowLeft;
